import { gql } from 'react-apollo';

export const getCurrentUserSuccessReports = gql`
  query getCurrentUserSuccessReports($id: Int!) {
    current_user {
      id
      type
      photo {
        small
      }
    },
    church: church_by_id(id: $id) {
      id
      revival {
        id
        phase
        endDate: end_date
        successReports: success_reports {
          edges {
            node {
              id
              title
              text
              type
              author {
                id
                name
                type
                photo {
                  small
                }
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/successReports/queries/getCurrentUserSuccessReports.js